/**
 * Reducer for any errors that might need to appear
 */

import { ActionTypes as types } from '../constants'

const initialState = {}

/**
 * Reducer. Pure function that mutates this part of the store
 * and returns a new obj.
 *
 */
export default function errors(state = initialState, action) {
  const { data } = action

  switch (action.type) {
    case types.SHOW_ERROR_BANNER:
      return {
        ...state,
        banner: { message: data.message },
      }
    case types.SHOW_ERROR_PAGE:
      return {
        ...state,
        page: data.errorCode,
      }

    /**
     * An async response from the server shouldn't clear error messages.
     * E.g. if we have 2 requests happening at the same time and the first one errors,
     * we wouldn't want the second one clearing the error when it returns successfully.
     */
    case types.RECEIVED_CURRENCY_CODE_LIST:
    case types.RECEIVED_DESTINATION_PRIMARY_CURRENCY_CODE:
    case types.RECEIVED_RECIPIENT_DETAILS:
    case types.RECEIVED_COUNTRY_DATA:
    case types.RECEIVED_FEE:
    case types.RECEIVED_ORIGIN_AMOUNT:
    case types.RECEIVED_DESTINATION_AMOUNT:
    case types.RECEIVED_EXCHANGE_RATE:
    case types.RECEIVED_CONTACTS:
      return state

    default:
      // any other action resets the current error
      return {
        ...state,
        banner: null,
        page: null,
      }
  }
}
